import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { QUICK_ACTIONS, QUICK_ACTION_PARAM } from "./searchRegistry";

// Runs a page's own Add action when the page was opened from a search quick
// action (`?quick=<id>`). `items` are the page's Add menu entries
// ({ label, onClick }); the one whose label matches the quick action runs,
// so the page's permission and configuration checks still apply. Waits
// until `ready` (data and settings loaded). The param is removed either
// way, so a refresh doesn't reopen the drawer.
export const useQuickActionFromUrl = (items, ready) => {
  const location = useLocation();
  const history = useHistory();
  const wanted = new URLSearchParams(location.search).get(QUICK_ACTION_PARAM);
  const itemsRef = useRef(items);
  itemsRef.current = items;

  useEffect(() => {
    if (!wanted || !ready) return;
    const params = new URLSearchParams(location.search);
    params.delete(QUICK_ACTION_PARAM);
    const rest = params.toString();
    history.replace({ pathname: location.pathname, search: rest ? `?${rest}` : "", hash: location.hash });
    const action = QUICK_ACTIONS.find((entry) => entry.id === wanted);
    const item = action && (itemsRef.current || []).find((entry) => entry?.label === action.title);
    if (item?.onClick) item.onClick();
  }, [wanted, ready, history, location.pathname, location.search, location.hash]);
};
